<template>
  <div>
    <v-dialog v-model="dialogSuccess" max-width="500px">
      <v-card class="white-background">
        <v-card-title>
          <span class="blue-text">
            Thank you for your registration for the NQSTIP.
            Our team has received your registration and you will be contacted by an inspector within 3-5 business days.
          </span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn class=" mt-5 " @click="dialogSuccess = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="500px">
      <v-card class="white-background">
        <v-card-title>
          <span class="blue-text">
             Oops! Something went wrong. Try again later please! If you are not using the latest version of
              chrome or firefox try downloading these browsers.
          </span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn class=" mt-5 " @click="dialogError = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-content class="">

      <section  v-cloak>
        <v-parallax
                :src="require('@/assets/beach-tsv2.jpg')"
                height="500"
                class="banner"
        >
          <Navbar></Navbar>

          <v-layout column class="white--text " justify-end>
            <div>
              <v-container justify-end>
                <div class=" display-1  mt-3 subpage-heading-1 ">
                  Request an NQSTIP Inspection
                </div>
                <div class=" headline  mt-3 subpage-heading-2 ">
                  Participate and get your property assessed!
                </div>
              </v-container>
            </div>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-container grid-list-xl class=" white-background">
          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-card class="elevation-0 transparent text-center">
                <h2 class="headline pa-2">Body Corporate Inspection Request</h2>
                <span class="subheading pa-2"> Registration for Authorized Person (AP)</span>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <section id="start" class="">
        <v-container class="   white-background" id="start">
          <div v-if="isSending" class="display-1 max-height ack-msg blue--text" >
            <v-progress-circular indeterminate
                                 color="blue">

            </v-progress-circular>
          </div>
          <div v-if="isSent"  class="display-1 max-height ack-msg blue--text"> Thank you for your registration for the NQSTIP. Our team has received your registration and you will contacted by an inspector within 3-5 business days.</div>
          <div v-if="isError" class="display-1 max-height ack-msg blue--text" > Oops! Something went wrong. Try again later please! If you are not using the latest version of
            chrome or firefox try downloading these browsers.</div>
          <v-form v-if="!isSending && !isSent && !isError" ref="form" v-model="valid" lazy-validation class=" ma-5 pa-5 max-height">
            <v-text-field
                    v-model="name"
                    :counter="30"
                    :rules="nameRules"
                    label="First Name"
                    required
            ></v-text-field>
            <v-text-field
                    v-model="lastName"
                    :counter="30"
                    :rules="lastNameRules"
                    label="Last Name"
                    required
            ></v-text-field>
            <v-text-field
                    v-model="organisation"
                    :counter="30"
                    :rules="organisationRules"
                    label="Organisation"
                    required
            ></v-text-field>
            <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
            ></v-text-field>
            <div class="hint">
              Please provide the address of property to be inspected:
            </div>
            <v-text-field
                    v-model="addressLine1"
                    label="Address Line 1"
                    :rules="addressLine1Rules"
                    :counter="100"
                    required
            ></v-text-field>
            <v-text-field
                    v-model="city"
                    label="City or Suburb"
                    :rules="cityRules"
                    :counter="100"
                    required
            ></v-text-field>
            <v-text-field
                    v-model="postcode"
                    label="Postcode"
                    :rules="postcodeRules"
                    :counter="4"
                    :mask="mask"
                    required
            ></v-text-field>
            <div class="hint">
              Only Queensland postcodes are currently accepted. PO Boxes are
              not allowed.
            </div>
            <v-text-field
                    v-model="phone"
                    :counter="30"
                    :rules="phoneRules"
                    label="Phone"
                    required
            ></v-text-field>
            <v-text-field
                    v-model="ctsn"
                    :counter="10"
                    :rules="ctsnRules"
                    label="Community Title Scheme Number"
                    required
                    type="number"
            ></v-text-field>
            <v-text-field
                    v-model="units"
                    :counter="4"
                    :rules="unitsRules"
                    type="number"
                    label="Number of Residential Units"
                    required
            ></v-text-field>
            <v-radio-group
                    v-model="residential"
                    row
                    label="Is this property primarily residential?"
                    mandatory

            >
              <v-radio
                      label="Yes"
                      value="Yes"
              ></v-radio>
              <v-radio
                      label="No"
                      value="No"
              ></v-radio>
            </v-radio-group>
            <!-- <div class="hint">
              Check all that apply:
            </div>
           <v-checkbox
                    v-model="gated"
                    label="Gated Community"
            ></v-checkbox>
            <v-checkbox
                    v-model="duplex"
                    label="Duplex, Semi-Detached, Maisonettes"
            ></v-checkbox>-->
            <v-text-field
                    v-model="comments"
                    label="Comments (Please provide the insurance renewal date, and the name, phone, and email of the person that will be on-site during the inspection if applicable.)"
                    :rules="commentsRules"
                    :counter="256"
            ></v-text-field>
            <v-checkbox
                    v-model="checkbox"
                    :rules="[v => !!v || 'You must agree to continue!']"
                    required
            >
                  <span slot="label"
                  >By checking this box you acknowledge that you have read and
                    understood the<a class="blue--text" @click="gotoPrivacy"
                    >Limitations and Disclaimer</a
                    >for the Program. You also attest to being the Authorised
                    Person for the above site, voted in by the Body Corporate
                    Committee. See<a class="blue--text" @click="gotoHelp"
                    >Help</a
                    >for the definition of 'Authorised Person'.
                  </span>
            </v-checkbox>
            <div class="hint">
              After successfully registering you will be contacted by an inspector within 3 to 5 business days.
            </div>

            <div class="warn mb-3">
              Please note that we do not support Internet Explorer
              (including IE 11 and all previous versions). If you are having
              issues entering or submitting your site please try downloading
              and installing<a
                    href="https://www.mozilla.org/en-US/firefox/new/"
            >Firefox</a
            >or<a href="https://www.google.com/chrome/">Chrome.</a>
            </div>

           <!-- <vue-recaptcha sitekey="6LcdA-sUAAAAACY3PDpy9wbefYtCLoQq05z07ktp"
                           @verify="verify"
                           @expired="onCaptchaExpired"
                           ref="recaptcha"
            >
            </vue-recaptcha>-->
            <v-layout row justify-center align-center v-if="isVerifying">
              <v-progress-circular
                      :size="50"
                      color="primary"
                      indeterminate
              ></v-progress-circular>
            </v-layout>

            <!--  || !verified -->
            <v-btn
                    :disabled="!valid "
                    class="blue lighten-2 ml-0 mt-3 mb-5 white--text"
                    @click="$vuetify.goTo('#start');validate();"
            >
              Register
            </v-btn>
          </v-form>

        </v-container>
      </section>
      <Footer></Footer>
    </v-content>
  </div>
</template>

<style>
.darken-img {
  filter: brightness(50%);
}
.white-background {
  background-color: white !important;
}
.gray-background {
  background-color: #e7e7e7 !important;
}
.v-parallax__image-container:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 770px;
  background-image: linear-gradient(
    to right top,
    #051937,
    #004d7a,
    #008793,
    #00bf72,
    #a8eb12
  );
  opacity: 0.3;
  z-index: 10;
}

[v-cloak] {
  display: none;
}
.admin-msg {
  font-size: 20px;
  font-weight: 500;
}
.hint {
  font-size: 15px;
  font-weight: 500;
}

.warn {
  font-size: 15px;
  font-weight: 500;
  color: red;
}

.subpage-heading-1 {
}
.subpage-heading-2 {
  margin-bottom: 20px;
}
.white-background {
  background-color: white;
}
.stepper-wrapper {
  height: 250px;
}

.stepper-top {
  height: 100px;
}

.stepper-bottom {
  height: 100px;
}

.stepper-icon {
  width: 100%;
}
.max-height{
  height: 1300px !important;

}
.ack-msg{
  text-align: center;
  justify-content: center;
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 100px;
}
</style>

<script>
import { router } from "../router";
import { Email } from "../smtp/smtp";
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";
import { siteService } from "../services";
import { userService } from "../services";
import VueRecaptcha from 'vue-recaptcha';


export default {
  name: "Home",
  components: {
    Navbar,
    Footer,
    /*VueRecaptcha*/
  },
  data: () => ({
    verified: false,
    isVerifying: false,
    isSending: false,
    isSent: false,
    isError: false,
    dialogSuccess: false,
    dialogError: false,
    valid: false,
    valid1: false,
    name: "",
    lastName: "",
    name1: "",
    addressLine1: "",
    city: "",
    postcode: "",
    address1: "",
    mask: "####",
    comments: "",
    nameRules: [
      v => !!v || "First Name is required",
      v => (v && v.length <= 30) || "First Name must be less than 30 characters"
    ],
    lastNameRules: [
      v => !!v || "Last Name is required",
      v => (v && v.length <= 30) || "Last Name must be less than 30 characters"
    ],
    addressLine1Rules: [
      v => !!v || "Address Line 1 is required",
      v =>
        (v && v.length <= 100) ||
        "Address Line 1 must be less than 100 characters"
    ],
    cityRules: [
      v => !!v || "City or Suburb is required",
      v =>
        (v && v.length <= 100) ||
        "City or Suburb must be less than 100 characters"
    ],
    postcodeRules: [
      v => !!v || "Postcode is required",
      v => (v && v.length <= 4) || "Postcode must be less than 4 characters",
      v =>
        (v && parseInt(v) >= 4000 && parseInt(v) <= 4999) ||
        "Only Queensland postcodes are currently accepted. PO Boxes are not allowed."
    ],
    addressRules1: [
      v => !!v || "Address is required",
      v => (v && v.length <= 100) || "Address must be less than 100 characters"
    ],
    nameRules1: [
      v => !!v || "Name is required",
      v => (v && v.length <= 30) || "Name must be less than 30 characters"
    ],
    organisation: "",
    organisation1: "",
    organisationRules: [
      v => !!v || "Organisation is required",
      v =>
        (v && v.length <= 30) || "Organisation must be less than 30 characters"
    ],
    organisationRules1: [
      v => !!v || "Organisation is required",
      v =>
        (v && v.length <= 30) || "Organisation must be less than 30 characters"
    ],
    email: "",
    email1: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    emailRules1: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    phone: "",
    phone1: "",
    phoneRules: [
      v => !!v || "Phone No. is required",
      v =>
        (v && v.length <= 30) || "Phone number must be less than 30 characters"
    ],
    phoneRules1: [
      v => !!v || "Phone No. is required",
      v =>
        (v && v.length <= 30) || "Phone number must be less than 30 characters"
    ],
    ctsn: "",
    ctsn1: "",
    ctsnRules: [
      v => !!v || "Community Title Scheme No. is required",
      v =>
        (v && v.length <= 10) ||
        "Community Title Scheme No. must be 10 characters or less"
    ],
      units: "",

      unitsRules: [
          v => !!v || "Number of Residential Units is required",
          v =>
              (v && v.length <= 4) ||
              "Number of Residential Units must be less than 5 characters"
      ],
    ctsnRules1: [
      v => !!v || "Strata Title Id No. is required",
      v =>
        (v && v.length <= 10) ||
        "Strata Title Id No. must be less than 10 characters"
    ],
    residential : "Yes",
    commentsRules: [
      v =>
        (v.length <= 256) ||
        "Comments must be less than 256 characters"
    ],
    checkbox: false,
    checkbox1: false,
    gated: false,
    duplex: false
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {

        this.isSending = true;
        //this.$refs.recaptcha.reset();


        const data = {
          first: this.name,
          last: this.lastName,
          org: this.organisation,
          suburb: this.city,
          email: this.email,
          phone: this.phone,
          comments: this.comments,
          ctsn: this.ctsn,
          postcode: this.postcode,
          address: this.addressLine1,
          gated: this.gated,
          duplex: this.duplex,
          units: this.units,
          residential: this.residential,
        };
        siteService.mail(data).then(

          response => {
            this.isSending = false;
            this.isSent = true;
            this.verified = false;
            this.dialogSuccess = true;


          },
          error => {
            this.isError = true;
            this.isSent = false;
            this.isSending = false;
            this.verified = false;
            this.dialogError = true;


          }
        );

       /* Email.send({
          SecureToken: "87e3dcc0-9ccb-4272-aaa4-5b8819df04c8",
          To: "stratatitle@jcu.edu.au",
          From: "svkk786@gmail.com",
          Subject: "This is an NQSTIP Registration Email",
          Body:
            "Registration alert with Name: " +
            this.name +
            " " +
            this.lastName +
            ", Organisation: " +
            this.organisation +
            ", Email: " +
            this.email +
            ", Address Line 1: " +
            this.addressLine1 +
            ", City or Suburb: " +
            this.city +
            ", Postcode: " +
            this.postcode +
            ", Phone: " +
            this.phone +
            ", CTSN: " +
            this.ctsn
        })
          .then
          //message => alert(message)
          ();*/
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    gotoPrivacy() {
      router.push("/agreement");
    },
    gotoHelp() {
      router.push("/faq");
    },
    verify(response){
        this.isVerifying = true;
        userService.validate({Response: response}).then(
            response => {
                this.verified = true;
                this.isVerifying = false;
            },
            error => {
                this.verified = false;
                this.isVerifying = false;
                this.$refs.recaptcha.reset();
            }
        );

    },
    onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
        this.verified = false;
    }
  }
};
</script>
